<div>
  <!-- PaymentRequestId -->
  <div class="card-field">
    <div class="card-field-label">{{ 'paymentRequestInformation.details.paymentRequestIdFieldLabel' | translate }}</div>
    <div class="card-field-content">{{ currentObject.PaymentRequestId }}</div>
  </div>

  <!-- Description -->
  <div class="card-field">
    <div
      class="card-field-label">{{ 'paymentRequestInformation.details.remittanceInformationFieldLabel' | translate }}
    </div>
    <div class="card-field-content">{{ currentObject.RemittanceInformation }}</div>
  </div>

  <!-- Amount -->
  <div class="card-field">
    <div class="card-field-label">{{ 'paymentRequestInformation.details.amountFieldLabel' | translate }}</div>
    <div class="card-field-content">{{ currentObject.AmountCurrency }}</div>
  </div>

  <div class="row">
    <!-- Debtor Name -->
    <div class="card-field col-4">
      <div class="card-field-label">{{ 'paymentRequestInformation.details.debtorNameFieldLabel' | translate }}</div>
      <div class="card-field-content">{{ currentObject.DebtorName }}</div>
    </div>
  </div>

  <div class="row">
    <!-- CreatedAt -->
    <div class="card-field col-4">
      <div class="card-field-label">{{ 'paymentRequestInformation.details.createdAtFieldLabel' | translate }}</div>
      <div class="card-field-content">{{ currentObject.CreatedAt | date:'d-M-y HH:mm:ss' }}</div>
    </div>

    <!-- LastChangedAt -->
    <div class="card-field col-4">
      <div class="card-field-label">{{ 'paymentRequestInformation.details.lastChangedAtFieldLabel' | translate }}</div>
      <div class="card-field-content">{{ currentObject.LastChangedAt | date:'d-M-y HH:mm:ss' }}</div>
    </div>

    <!-- CompletedAt -->
    <div class="card-field col-4">
      <div class="card-field-label">{{ 'paymentRequestInformation.details.completedAtFieldLabel' | translate }}</div>
      <div class="card-field-content">{{ currentObject.CompletedAt | date:'d-M-y HH:mm:ss' }}</div>
    </div>
  </div>

  <div class="row">
    <!-- ExpirationDate -->
    <div class="card-field col-4">
      <div class="card-field-label">{{ 'paymentRequestInformation.details.expirationDateFieldLabel' | translate }}</div>
      <div class="card-field-content">{{ currentObject.ExpirationDate | date:'d-M-y HH:mm' }}</div>
    </div>
  </div>

  <div class="row">
    <!-- Status -->
    <div class="card-field col-4">
      <div class="card-field-label">{{ 'paymentRequestInformation.details.statusIconClassFieldLabel' | translate }}
      </div>
      <div class="card-field-content"><i [ngClass]="currentObject.Status.IconClass"
                                         title="{{currentObject.Status.Hint}}"></i></div>
    </div>

    <!-- Status Hint -->
    <div class="card-field col-8">
      <div class="card-field-label">{{ 'paymentRequestInformation.details.statusDescription' | translate }}</div>
      <div class="card-field-content">{{ currentObject.Status.Hint }}</div>
    </div>
  </div>
</div>
